import React, { forwardRef } from 'react';
import clsx from 'clsx';
import styles from './styles.module.css';
export const BaseBreadcrumbs = /*#__PURE__*/forwardRef(function BaseBreadcrumbs({
  className,
  addSEOAttributes,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: clsx(styles.breadcrumbs, className),
    ...(addSEOAttributes && {
      itemScope: true,
      itemType: 'http://schema.org/BreadcrumbList'
    }),
    role: "navigation",
    "aria-label": "breadcrumbs",
    "data-testid": "breadcrumbs",
    ...rest
  });
});